import { useMaybeRoutes } from '@/features/router/route'
import type { MatchEntrance } from '@/types/app'
import type { Ref } from 'vue'
import { watch } from 'vue'

export const useSelectFirst = (
  matches: Ref<MatchEntrance[]>,
  selectMatch: (match: MatchEntrance) => void
) => {
  const maybeIndexRoute = useMaybeRoutes([
    'ownChatIndex',
    'memberChatIndex',
    'assignedChatIndex',
  ])

  // 1番目に飛ぶ実装
  watch(
    [matches, maybeIndexRoute],
    ([list, newMaybeIndexRoute]) => {
      const [first] = list ?? []
      if (first === undefined) {
        return
      }
      if (newMaybeIndexRoute === undefined) {
        return
      }
      selectMatch(first)
    },
    { immediate: true }
  )
}
